import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class PercentageofbreakEditService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }


	loadPercent(token, ID) {

		return this.http
		.get(this.apiUrl + "percentageofbreak/v1/getcodpercentageofbreak/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	editPercent(token, percent: any) {
		return this.http
		.put(this.apiUrl + "percentageofbreak/v1/updatepercentageofbreak", percent, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/percentageofbreak/service/percentageofbreak-edit/percentageofbreak-edit.service.ts